export const roles = [
  {
    id: 1,
    value: "regional_inspector",
    name: "Инспектор РУ",
    description: "There is some text for explaining section"
  },
  { id: 2, value: "auditor", name: "Аудитор", description: "There is some text for explaining section" },
  { id: 3, value: "energetic", name: "Энергетик", description: "There is some text for explaining section" }
]
